import React from 'react'
import { useTranslation } from 'react-i18next';

const SmallLoading = () => {
    const {t} = useTranslation();

    return (
        <h6 className='text-center' style={{fontSize: '.8rem', marginTop: '.5rem'}}> {t("loading")} </h6>
    )
}

export default SmallLoading